import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { UMPSection } from './components/UMPSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
import { LiveVisitorCounter } from './components/LiveVisitorCounter';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <RecentPurchaseNotification data-id="element-2" />
      <LiveVisitorCounter data-id="element-3" />
      <Header data-id="element-4" />
      <main className="flex-grow" data-id="element-5">
        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <UMPSection data-id="element-8" />
        <ProductSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <PricingSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}